<header>
    <div class="row" style="padding-left: 15px;">
        <div class="medium-7 small-10">
            <div style="display:inline-block">
                <a routerLink="/" tabindex="0" class="logo-icon">
                    <h1 class="header-title show-for-medium"><span>iGrade</span></h1>
                    <h1 class="header-title show-for-small-only">{{ mobileTitle }}</h1>
                </a>
            </div>
        </div>
        <div class="small-2 show-for-small-only mobile-menu-toggle-container">
            <button class="app-icon-button menu-toggle show-for-small-only" (click)="toggleSideNav()">
                <i [@menuButtonState]="menuIconState" class="material-icons app-toolbar-menu">menu</i>
                <i [@menuButtonState]="closeIconState" class="material-icons app-toolbar-menu">close</i>
            </button>
        </div>
        <div class="medium-5 small-1 show-for-medium">
            <app-header-menu (mayEditTextEvent)="textComponentEvent($event)"></app-header-menu>
        </div>
    </div>

</header>
<div class="menu-bar">
    <app-breadcrumbs></app-breadcrumbs>
</div>

